import { render } from "./FormManterRefeicao.vue?vue&type=template&id=242dee54"
import script from "./FormManterRefeicao.vue?vue&type=script&lang=js"
export * from "./FormManterRefeicao.vue?vue&type=script&lang=js"

import "./FormManterRefeicao.vue?vue&type=style&index=0&id=242dee54&lang=css"
/* custom blocks */
import block0 from "./FormManterRefeicao.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__